import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import {
  Button,
  Typography,
  message,
  Spin,
} from "antd";
import { genericApiCall, spacerData } from "./CommonApiCallCalender";
import { Config } from "../Common/Config";
import "./ClinicBooking.css";
import useDebounce from "../Common/useDebounce";
import ClinicMap from "./ClinicMap";
import dayjs from "dayjs";
import moment from "moment";
import DatePickerPopover from "../Shared/DatePickerPopover";
import LocationSearchSelect from "../Shared/LocationSearchSelect";
import {
  filterByNonGpProductId,
} from "../Common/CommonFunction";
import { formatString } from "../Common/ColorCode";
import { pushTraceLogEvent, pushTraceLogOnClose, logInteraction } from "./sessionEventPush";

const CalendarIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#008385"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

const ClockIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#008385"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
  >
    <circle cx="12" cy="12" r="9"></circle>
    <polyline points="12 7 12 12 16 14"></polyline>
  </svg>
);

const { Title } = Typography;

const ClinicBooking = (props) => {
  const [selectedClinics, setSelectedClinics] = useState([]);
  const [selectedClinicsNew, setSelectedClinicsNew] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setloading] = useState(false);
  const [loadingLocation, setloadingLocation] = useState(false);
  const [loadingTime, setloadingTime] = useState(false);
  const [loadingMoreDates, setloadingMoreDates] = useState(false);
  const [searchBylocationName, setsearchBylocationName] = useState("");
  const [searchBylocationOption, setsearchBylocationOption] = useState([]);
  const [cordData, setcordData] = useState([]);
  const [clickedClinicIdItem, setClickedClinicItem] = useState(null);
  const [hoveredClinic, setHoveredClinic] = useState(null);

  // ── Slot / time state ─────────────────────────────────────────────────────
  // No mock data — starts empty, only populated after clinic is selected.
  // NOTE: slots now live on each clinic entry in `selectedClinicsNew[].available_dates`
  // (IOO-324 v2 migration to `get-available-slots`) — no separate flat slot state.
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedClinicsStartAndEndTime, setselectedClinicsStartAndEndTime] = useState([]);
  const [blockingSlot, setBlockingSlot] = useState(false);
  const [metaData, setmetaData] = useState(null);
  const [locationCoords, setLocationCoords] = useState(null);
  const [chosenDates, setChosenDates] = useState(new Set());
  const [dpOpen, setDpOpen] = useState(false);
  const [openDates, setOpenDates] = useState(new Set());
  const [openClinics, setOpenClinics] = useState(new Set());
  const [clinicFilters, setClinicFilters] = useState({});

  // Right panel (dates/location) height is pinned to the left panel's
  // (clinic list) natural rendered height, so the right panel scrolls
  // internally instead of both panels stretching to whichever side's
  // content is taller. Only applies on desktop — below the tablet
  // breakpoint the columns stack, so the page itself scrolls and neither
  // panel should have a fixed height.
  const leftPanelRef = useRef(null);
  const [rightPanelHeight, setRightPanelHeight] = useState(null);
  const [isDesktopLayout, setIsDesktopLayout] = useState(
    () => typeof window === 'undefined' || window.innerWidth > 768
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia('(min-width: 769px)');
    const handler = (e) => setIsDesktopLayout(e.matches);
    mq.addEventListener ? mq.addEventListener('change', handler) : mq.addListener(handler);
    return () => {
      mq.removeEventListener ? mq.removeEventListener('change', handler) : mq.removeListener(handler);
    };
  }, []);

  useEffect(() => {
    const node = leftPanelRef.current;
    if (!node || typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver((entries) => {
      const height = entries[0]?.contentRect?.height;
      if (height) setRightPanelHeight(height);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  // Defensive re-measure after every render — the ResizeObserver above should
  // catch every left-panel content change, but in practice the right panel's
  // height would freeze at whatever it first measured (e.g. the initial
  // loading/empty state) and never grow again once real clinic rows were
  // added. This runs after every commit and corrects it whenever the DOM
  // height and the stored height have drifted apart.
  useLayoutEffect(() => {
    const node = leftPanelRef.current;
    if (!node) return;
    const height = node.getBoundingClientRect().height;
    if (height && height !== rightPanelHeight) setRightPanelHeight(height);
  });

  const debouncedInputValueData = useDebounce(searchBylocationName, 800);

  // ── Booking summary chips ────────────────────────────────────────────────
  let tempDataForDuration = [];
  if (props.showAppoinmentData && props.showAppoinmentData.duration) {
    tempDataForDuration.push({
      key: "Duration",
      data:
        props.data && props.data.durationObjectById && props.showAppoinmentData.duration && props.data.durationObjectById[props.showAppoinmentData.duration]
          ? props.data.durationObjectById[props.showAppoinmentData.duration].duration + " minutes"
          : "15 minutes",
    });
  }
  const _cbSumCat = props.showAppoinmentData?.clinic?.productCategory;
  const _cbSumProd = props.showAppoinmentData?.selectedProduct;
  const _cbIsGp = _cbSumCat?.type === 'gp' || _cbSumCat?.product_category_id == 1;
  const _cbAllowLang = _cbIsGp || _cbSumProd?.allow_language_selection || _cbSumCat?.allow_language_selection;
  const _cbAllowGender = _cbIsGp || _cbSumProd?.allow_gender_selection || _cbSumCat?.allow_gender_selection;
  if (_cbAllowLang && props.showAppoinmentData && props.showAppoinmentData.language) {
    let data = "";
    if (props.showAppoinmentData.language?.value) data = props.showAppoinmentData.language.value;
    else data = props.showAppoinmentData.language;
    let languageName = props.data.languageData.find(l => l.value == data);
    const _cbLangLabel = languageName ? languageName.label : data;
    if (_cbLangLabel && String(_cbLangLabel).toLowerCase() !== 'english') {
      tempDataForDuration.push({ key: "Language", data: _cbLangLabel });
    }
  }
  if (_cbAllowGender && props.showAppoinmentData && props.showAppoinmentData.gender) {
    tempDataForDuration.push({
      key: "Gender",
      data: props.showAppoinmentData.gender ? formatString(props.showAppoinmentData.gender) : "",
    });
  }

  // ── Effects ───────────────────────────────────────────────────────────────
  useEffect(() => {
    if (debouncedInputValueData) getAllSearchData(debouncedInputValueData);
  }, [debouncedInputValueData]);

  useEffect(() => {
    fetchAvailableSlots(1, true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.bookingSessionId]);

  // Opens the first 3 loaded dates (and every checked clinic's nest within
  // them) — the default browsing view's starting state, used both the first
  // time a clinic is selected and again after the admin clears chosen dates
  // back to browsing mode.
  const openFirst3Dates = () => {
    const selectedObjs = selectedClinics
      .map(cid => selectedClinicsNew?.find(c => c.id?.toString() === cid))
      .filter(Boolean);
    const dayKeys = [...new Set(selectedObjs.flatMap(c => Object.keys(c.available_dates || {})))]
      .sort()
      .slice(0, 3);
    if (dayKeys.length) {
      setOpenDates(new Set(dayKeys));
      setOpenClinics(prev => {
        const next = new Set(prev);
        dayKeys.forEach(d => selectedClinics.forEach(cid => next.add(`${d}_${cid}`)));
        return next;
      });
    }
  };

  // Set when chosen dates are cleared, so the *next* selectedClinicsNew update
  // (the fresh default-view fetch triggered by that clear) re-opens the first
  // 3 dates using up-to-date data — chosenDates changing fires before that
  // fetch resolves, so opening immediately there would use stale, date-scoped
  // data still left over from before the clear.
  const justClearedDatesRef = useRef(false);

  const prevSelCountRef = useRef(0);
  // Auto open first 3 dates the first time the admin selects any clinic
  // (data for all clinics is already loaded — no fetch needed to do this).
  useEffect(() => {
    if (selectedClinics.length > 0 && prevSelCountRef.current === 0) {
      openFirst3Dates();
    } else if (justClearedDatesRef.current) {
      justClearedDatesRef.current = false;
      openFirst3Dates();
    }
    prevSelCountRef.current = selectedClinics.length;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClinics, selectedClinicsNew]);

  // Auto-open the date card(s) matching whatever is picked in the "Select dates"
  // popover — 1 date chosen opens exactly 1 card, 2 chosen opens 2 — and each
  // checked clinic's nest within them, so results are visible immediately
  // without extra manual clicks (mirrors the first-3-dates auto-open above).
  // Clearing chosen dates back to 0 reverts to the default browsing view —
  // defer re-opening the first 3 dates to the effect above (see justClearedDatesRef).
  const prevChosenDatesSizeRef = useRef(0);
  useEffect(() => {
    if (chosenDates.size > 0) {
      setOpenDates(new Set(chosenDates));
      setOpenClinics(prev => {
        const next = new Set(prev);
        chosenDates.forEach(d => selectedClinics.forEach(cid => next.add(`${d}_${cid}`)));
        return next;
      });
    } else if (prevChosenDatesSizeRef.current > 0) {
      justClearedDatesRef.current = true;
    }
    prevChosenDatesSizeRef.current = chosenDates.size;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chosenDates]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        pushTraceLogOnClose({
          event: "browser_closed_or_minimized",
          payload: { step: "preferred_time_selection" },
          step_status: "success",
          meta: { reason: "tab_close_or_background" },
        });
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  // ── API: location text search ─────────────────────────────────────────────
  const getAllSearchData = async (payload) => {
    if (payload && payload.split(' ').join('').length >= 3) {
      setloadingLocation(true);
      pushTraceLogEvent({ event: "address_search_api_called", payload: { search_query: payload, step: "clinic_selection" }, step_status: "success" });
      let csrRoomData = await spacerData("get-address", { input: payload });
      if (csrRoomData?.data?.data) {
        setsearchBylocationOption(csrRoomData.data.data.map(a => ({ value: `${a.lat}::${a.lng}`, label: a.address })));
        pushTraceLogEvent({ event: "address_search_results_received", payload: { search_query: payload, step: "clinic_selection" }, step_status: "success" });
      }
      setloadingLocation(false);
    }
  };

  const onSelectLocation = (data) => {
    const parts = data.split("::") ?? [];
    if (parts.length === 2) {
      logInteraction("address_selected_from_dropdown", { lat: parts[0], lng: parts[1] });
      const coords = { lat: parts[0], lng: parts[1] };
      setLocationCoords(coords);
      fetchAvailableSlots(1, true, coords);
    }
  };

  // ── API: unified available-slots fetch (IOO-324 v2 — /api/admin/v2/get-available-slots) ──
  // Replaces the old two-call preferred-clinics + preferred-time/page/{n} pattern.
  // NOTE: this endpoint has no `clinic_ids` param — it always returns every eligible
  // clinic (with its own `available_dates`); which clinics are actually *displayed*
  // is purely a client-side selection (`selectedClinics`, capped at 3), not a fetch scope.
  // It also has no `preferred_dates` param (only a start/end range) — when the admin
  // picks 1-2 specific dates we fire one call per date and merge, rather than trusting
  // a single range call (which would misbehave if the 2 dates are >10 days apart).
  const buildAvailableSlotsPayload = (preferredBy, coords, dateOverride) => {
    const _pid = props.showAppoinmentData?.clinic?.productCategory?.product_category_id;
    const catType = props.showAppoinmentData?.clinic?.productCategory?.type || (_pid == 1 ? 'gp' : _pid == 3 ? 'corporate' : 'd2c');
    let data = { preferred_by: preferredBy, product_category_id: _pid ?? 1 };
    if (catType !== 'gp') {
      data.product_id = props.showAppoinmentData?.clinic?.non_gp_product_id ?? null;
    } else {
      data.duration_id = props.showAppoinmentData?.duration ?? 1;
    }
    const isReshedula = props.showAppoinmentData?.clinic?.isReshedula;
    const calenderData = props.showAppoinmentData?.clinic?.calenderData;
    if (isReshedula && calenderData?.appointment_id) {
      data.appointment_id = calenderData.appointment_id;
    }
    const effectiveGender = isReshedula ? (props.showAppoinmentData?.gender ?? calenderData?.preferred_gender) : props.showAppoinmentData?.gender;
    if (effectiveGender && effectiveGender !== "no_preference") data.gender = effectiveGender;
    if (props.showAppoinmentData?.language) {
      data.languages = [props.showAppoinmentData?.language?.value ?? props.showAppoinmentData?.language];
    }
    if (coords?.lat && coords?.lng) { data.lat = coords.lat; data.lng = coords.lng; }
    const sid = localStorage.getItem("bookingSessionId");
    if (sid && sid !== "undefined") data.slot_session_id = sid;
    if (dateOverride) { data.start_date = dateOverride; data.end_date = dateOverride; }
    return data;
  };

  const normalizeClinics = (rawClinics) => (rawClinics || []).map(c => {
    const meta = props.data?.allClinicDataByID?.[c.clinic_id] || {};
    return { ...meta, ...c, id: c.clinic_id, name: c.clinic_name };
  });

  const mergeClinicsData = (existingList, freshList) => {
    const byId = new Map((existingList || []).map(c => [String(c.id), c]));
    freshList.forEach(c => {
      const existing = byId.get(String(c.id));
      byId.set(String(c.id), existing
        ? {
            ...existing,
            ...c,
            // NOTE: `next_available_slot` is recomputed by the backend per-page,
            // scoped to that page's date window — a later page (or one where this
            // clinic has no slots) can return an older/`null` value that would
            // otherwise clobber an earlier, chronologically-correct one. Keep the
            // first non-null value seen (pages are fetched in date order).
            next_available_slot: existing.next_available_slot ?? c.next_available_slot,
            available_dates: { ...existing.available_dates, ...c.available_dates },
          }
        : c);
    });
    return Array.from(byId.values());
  };

  // Guards against out-of-order / duplicate responses (e.g. React StrictMode's
  // dev-only double-invoke of effects, or the admin changing location/dates
  // faster than a previous request resolves) overwriting newer state with stale data.
  const fetchSeqRef = useRef(0);

  const fetchAvailableSlots = async (pageNumber = 1, reset = true, coordsOverride = null, datesOverride = null) => {
    const seq = ++fetchSeqRef.current;
    const coords = coordsOverride ?? locationCoords;
    const activeDates = datesOverride !== null ? datesOverride : Array.from(chosenDates);
    if (pageNumber > 1) setloadingMoreDates(true);
    else { setloadingTime(true); if (reset) setloading(true); }

    // A date-scoped fetch (activeDates.length > 0, e.g. toggling a date in the
    // picker) must merge into the existing clinic list rather than rebuild it —
    // starting from [] here discarded distance/all_available_dates/ordering for
    // every clinic and caused the whole left panel to visibly reset on every
    // date toggle. Only a genuine full reset (initial load, location change,
    // clearing chosen dates) should start from [].
    let mergedClinics = (reset && activeDates.length === 0) ? [] : selectedClinicsNew;
    let nextMeta = metaData;

    if (activeDates.length > 0) {
      const responses = await Promise.all(activeDates.map(d => genericApiCall(
        "get-available-slots/page/1",
        buildAvailableSlotsPayload("clinic", coords, d),
        Config.urlV2,
        "available_slots_fetched",
      )));
      responses.forEach(res => {
        mergedClinics = mergeClinicsData(mergedClinics, normalizeClinics(res?.data?.data?.clinics));
      });
      // The merge above keeps each clinic's identity (name/address/distance/etc.)
      // but spreads existing.available_dates on top too, which would leave stale
      // dates from before the picker's date selection (e.g. the original 30-day
      // default view) still showing as cards on the right panel. Once specific
      // dates are chosen, only those dates should ever appear — drop the rest.
      mergedClinics = mergedClinics.map(c => ({
        ...c,
        available_dates: Object.fromEntries(
          activeDates.filter(d => c.available_dates?.[d]).map(d => [d, c.available_dates[d]])
        ),
      }));
      nextMeta = { current_page: 1, last_page: 1 };
    } else {
      const res = await genericApiCall(
        `get-available-slots/page/${pageNumber}`,
        buildAvailableSlotsPayload("clinic", coords, null),
        Config.urlV2,
        "available_slots_fetched",
      );
      mergedClinics = mergeClinicsData(mergedClinics, normalizeClinics(res?.data?.data?.clinics));
      nextMeta = { current_page: res?.data?.current_page ?? pageNumber, last_page: res?.data?.last_page ?? pageNumber };
    }

    if (seq !== fetchSeqRef.current) return; // a newer fetch has since started — discard this stale response
    setSelectedClinicsNew(mergedClinics);
    setmetaData(nextMeta);
    setloadingTime(false);
    setloadingMoreDates(false);
    setloading(false);
  };

  // ── Clinic toggle ─────────────────────────────────────────────────────────
  const toggleClinic = (clinic) => {
    const idStr = (clinic.id || clinic.clinic_id).toString();
    const isCurrentlySelected = selectedClinics.includes(idStr);
    let newSelected;

    if (isCurrentlySelected) {
      newSelected = selectedClinics.filter(id => id !== idStr);
      pushTraceLogEvent({ event: "clinic_unselected", payload: { clinic_id: idStr, clinic_name: clinic?.name, selected_clinic_ids: newSelected }, step_status: "success" });
    } else {
      if (selectedClinics.length >= 3) {
        messageApi.error({ type: "error", content: "You can only select up to 3 options." });
        return;
      }
      newSelected = [...selectedClinics, idStr];
      pushTraceLogEvent({ event: "clinic_selected", payload: { clinic_id: idStr, clinic_name: clinic?.name, selected_clinic_ids: newSelected }, step_status: "success" });
      
      // Auto-expand the newly selected clinic inside currently open dates
      setOpenClinics(oldOpen => {
        const next = new Set(oldOpen);
        openDates.forEach(d => next.add(`${d}_${idStr}`));
        return next;
      });
    }

    setSelectedClinics(newSelected);

    if (props.setshowAppoinmentData) {
      props.setshowAppoinmentData({ ...props.showAppoinmentData, selectedClinics: newSelected });
    }

    // Reset slot pick when clinic selection changes — no re-fetch needed, every
    // eligible clinic's slots were already loaded by the single get-available-slots call.
    setSelectedSlots([]);
    setselectedClinicsStartAndEndTime([]);

    // Update map cord data
    let tempData = [];
    newSelected.forEach(id => {
      if (props.data?.allClinicDataByID?.[id]?.latitude && props.data?.allClinicDataByID?.[id]?.longitude) {
        tempData.push({
          id,
          name: props.data.allClinicDataByID[id].name ?? "No data",
          data: [props.data.allClinicDataByID[id].latitude, props.data.allClinicDataByID[id].longitude],
        });
      }
    });
    setcordData(tempData);
    setClickedClinicItem(clinic);
  };

  // ── Slot toggle ───────────────────────────────────────────────────────────
  const toggleSlot = (slot, info, date, clinicId) => {
    if (selectedSlots.includes(slot)) {
      logInteraction("unselected_preferred_time", {
        selected_slot: `${info.start_time}-${info.end_time}`,
        day: date,
      });
      setSelectedSlots([]);
      setselectedClinicsStartAndEndTime([]);
      return;
    }
    setSelectedSlots([slot]);
    const id = `${date}${info.start_time}`;
    const newEntry = {
      id,
      end_time: info.end_time,
      start_time: info.start_time,
      info,
      clinic_id: clinicId ? [clinicId] : [],
      date,
    };
    setselectedClinicsStartAndEndTime([newEntry]);
    pushTraceLogEvent({
      event: "selected_preferred_time",
      payload: { selected_slot: `${info.start_time}-${info.end_time}`, day: date, clinic_id: clinicId },
      step_status: "success",
    });
  };

  // ── Date accordion toggles ────────────────────────────────────────────────
  const toggleDate = (dateStr) => {
    setOpenDates(prev => {
      const next = new Set(prev);
      if (next.has(dateStr)) { next.delete(dateStr); }
      else {
        logInteraction("date_card_expanded", { date: dateStr });
        next.add(dateStr);
        setOpenClinics(p => {
          const np = new Set(p);
          selectedClinics.forEach(cid => np.add(`${dateStr}_${cid}`));
          return np;
        });
      }
      return next;
    });
  };

  const toggleClinicNest = (dateStr, clinicId) => {
    const key = `${dateStr}_${clinicId}`;
    setOpenClinics(prev => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        logInteraction("clinic_time_nest_expanded", { date: dateStr, clinic_id: clinicId });
        next.add(key);
      }
      return next;
    });
  };

  const getLoadMoreData = () => {
    if (metaData && metaData.current_page && metaData.current_page < metaData.last_page) {
      logInteraction("load_more_clicked", {
        current_page: metaData.current_page,
        next_page: 1 + parseInt(metaData.current_page),
        last_page: metaData.last_page,
        screen: "clinic_booking",
      });
      fetchAvailableSlots(1 + parseInt(metaData.current_page), false);
    }
  };

  // ── Location details panel ────────────────────────────────────────────────
  const LocationDetailsPanel = () => {
    const activeClinic = hoveredClinic || clickedClinicIdItem || (selectedClinicsNew && selectedClinicsNew[0]);
    // cordData is only ever populated by the clinic-checkbox click handler, so
    // it's still [] here whenever activeClinic came from hovering or from the
    // selectedClinicsNew[0] default-display fallback — leaving the map's
    // MapContainer at its hardcoded center={[0,0]} (middle of the ocean) since
    // FitBounds's effect never gets a non-empty coordinates array to act on.
    // Deriving mapCordData from activeClinic itself (whichever of the three
    // sources it came from) instead of from cordData fixes that for every case.
    let mapCordData = cordData;
    if (activeClinic) {
      const aId = activeClinic.id || activeClinic.clinic_id;
      const aLat = activeClinic.latitude ?? props.data?.allClinicDataByID?.[aId]?.latitude;
      const aLng = activeClinic.longitude ?? props.data?.allClinicDataByID?.[aId]?.longitude;
      if (aLat != null && aLng != null) {
        mapCordData = [{ id: aId, name: activeClinic.name ?? "No data", data: [aLat, aLng] }];
      }
    }
    return (
      <div className="cbv2-panel" style={isDesktopLayout && rightPanelHeight ? { height: rightPanelHeight } : undefined}>
        <div className="cbv2-ph">
          <span className="cbv2-ptitle">Location details</span>
        </div>
        <div className="cbv2-map-card">
          {activeClinic ? (
            <div style={{ width: "100%", maxWidth: "400px", margin: "auto" }}>
              <div style={{ borderRadius: "10px", border: "1px solid rgba(0,131,133,1)", padding: "16px", background: "#fff" }}>
                <div style={{ width: "181px", height: "181px", margin: "0 auto" }}>
                  <ClinicMap widthAndheight={{ width: 181, height: 181 }} passData={{ cood: mapCordData, name: "No data" }} />
                </div>
                <p style={{ marginTop: "16px", textAlign: "center", fontSize: "15px", fontWeight: "600", color: "#008385" }}>
                  {activeClinic.name}
                </p>
                <p style={{ marginTop: "6px", marginBottom: "10px", textAlign: "center", fontSize: "13px", color: "#555" }}>
                  {activeClinic.address}
                </p>
                {activeClinic.clinic_website_description && (
                  <div
                    style={{ textAlign: "left", fontSize: "12px", lineHeight: "1.5", color: "rgba(74,74,74,1)" }}
                    dangerouslySetInnerHTML={{ __html: activeClinic.clinic_website_description }}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className="cbv2-empty-state">Hover over a clinic to view location details</div>
          )}
        </div>
      </div>
    );
  };

  // ── Preferred time slots panel ────────────────────────────────────────────
  const PreferredTimePanel = () => {
    const selectedClinicObjs = selectedClinics
      .map(cid => selectedClinicsNew?.find(c => c.id?.toString() === cid))
      .filter(Boolean);
    const allDayKeys = [...new Set(selectedClinicObjs.flatMap(c => Object.keys(c.available_dates || {})))].sort();
    // Drives the "Select dates" picker only — each clinic's own all_available_dates
    // gives its complete bookable range, unlike available_dates above which is
    // limited to whatever page(s) have been loaded so far.
    const datePickerAvailableDates = [...new Set(selectedClinicObjs.flatMap(c => c.all_available_dates || []))];

    return (
    <div className="cbv2-panel" style={isDesktopLayout && rightPanelHeight ? { height: rightPanelHeight } : undefined}>
      <div className="cbv2-ph">
        <span className="cbv2-ptitle">Preferred time</span>
      </div>

      {/* Date filter bar */}
      <div style={{ padding: '0.6rem 1rem', borderBottom: '1px solid var(--cb-border)', flexShrink: 0 }}>
        <div style={{ fontSize: 14, color: 'var(--cb-text-secondary)', marginBottom: 8 }}>
          {chosenDates.size > 0 ? 'Showing results for selected dates' : 'Select up to 2 preferred dates'}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
            {Array.from(chosenDates).map(dStr => (
              <span key={dStr} className="cbv2-fchip on" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                {moment(dStr).format("ddd, DD MMM")}
                <span style={{ cursor: 'pointer', fontSize: 12 }} onClick={() => {
                  const next = new Set(chosenDates);
                  next.delete(dStr);
                  setChosenDates(next);
                  logInteraction(next.size > 0 ? "preferred_dates_selected" : "preferred_dates_cleared", {
                    removed_date: dStr,
                    preferred_dates: Array.from(next),
                  });
                  fetchAvailableSlots(1, true, locationCoords, Array.from(next));
                }}>✕</span>
              </span>
            ))}
          </div>
          <div className="dp-popover-wrapper">
            <button className="dp-trigger-btn cbv2-loc-btn" style={{ width: 'auto', padding: '0 16px' }} onClick={() => {
              logInteraction("date_picker_opened", { currently_open: !dpOpen });
              setDpOpen(o => !o);
            }}>
              <CalendarIcon /> {chosenDates.size > 0 ? `${chosenDates.size}/2 dates` : 'Select dates'}
            </button>
            <DatePickerPopover
              open={dpOpen}
              onClose={() => {
                setDpOpen(false);
                // Fetch once, using whatever dates ended up chosen — not on every
                // individual date click while the popover is still open.
                fetchAvailableSlots(1, true, locationCoords, Array.from(chosenDates));
              }}
              chosenDates={chosenDates}
              maxDates={2}
              availableDates={datePickerAvailableDates}
              onDateToggle={(ymd) => {
                const next = new Set(chosenDates);
                if (next.has(ymd)) next.delete(ymd); else if (next.size < 2) next.add(ymd);
                setChosenDates(next);
                logInteraction("preferred_dates_selected", { preferred_dates: Array.from(next) });
              }}
              onClearAll={() => {
                setChosenDates(new Set());
                logInteraction("preferred_dates_cleared", {});
                fetchAvailableSlots(1, true, locationCoords, []);
              }}
            />
          </div>
        </div>
      </div>

      {/* Scrollable slots area */}
      <div className="cbv2-right-scroll">
        {loadingTime ? (
          <div style={{ textAlign: 'center', padding: '2rem' }}><Spin className="custom-spinner" /></div>
        ) : allDayKeys.length === 0 ? (
          <div className="cbv2-empty-state">No slots available for the selected dates.</div>
        ) : (
          allDayKeys.map(day => {
            const isDateOpen = openDates.has(day);
            const hasPick = selectedSlots.some(sk => sk.startsWith(day));

            return (
              <div key={day} className="cbv2-date-card">
                <div
                  className={`cbv2-date-card-header${isDateOpen ? ' is-open' : ''}${hasPick ? ' has-pick' : ''}`}
                  onClick={() => toggleDate(day)}
                >
                  <span className="cbv2-dchip">{moment(day).format("ddd, DD MMM")}</span>
                  <span className="cbv2-chevron">{isDateOpen ? '▲' : '▼'}</span>
                </div>

                {isDateOpen && (
                  <div className="cbv2-clinic-nest">
                    {(() => {
                      const clinicRows = selectedClinics.map(cid => {
                        const clinic = selectedClinicsNew?.find(c => (c.id || c.clinic_id) == cid) || { name: 'Clinic', id: cid };
                        const slotsForDay = clinic.available_dates?.[day] || [];
                        return { cid, clinic, slotsForDay, hasSlots: slotsForDay.length > 0 };
                      });
                      // Default browsing (no specific dates chosen): only show clinics
                      // that actually have a slot this day — with many date cards on
                      // screen, showing every checked clinic under every empty date
                      // would be noisy. Once specific dates are chosen, keep every
                      // checked clinic visible so the admin can compare, but tag the
                      // unavailable ones instead of hiding them.
                      const rowsToShow = chosenDates.size > 0
                        ? clinicRows
                        : clinicRows.filter(r => r.hasSlots);

                      if (rowsToShow.length === 0) return null;

                      return rowsToShow.map(({ cid, clinic, slotsForDay, hasSlots }) => {
                        const key = `${day}_${cid}`;
                        const isNestOpen = openClinics.has(key);
                        const filterVal = clinicFilters[key] || 'all';

                        let filtered = slotsForDay.filter(slot => {
                          if (filterVal === "am") return slot.start_time < "12:00";
                          if (filterVal === "pm") return slot.start_time >= "12:00";
                          return true;
                        });

                        const hasAM = slotsForDay.some(s => s.start_time < '12:00');
                        const hasPM = slotsForDay.some(s => s.start_time >= '12:00');

                        const pickedSlotItem = filtered.find(s => selectedSlots.includes(`${day}_${cid}_${s.start_time}-${s.end_time}`));
                        const pickedSlotLabel = pickedSlotItem ? pickedSlotItem.start_time : null;

                        return (
                          <div key={key} className="cbv2-nest-item">
                            <div
                              className={`cbv2-nest-row${isNestOpen ? ' open' : ''}${!hasSlots ? ' unavail' : ''}`}
                              onClick={() => hasSlots && toggleClinicNest(day, cid)}
                            >
                              <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
                                <span className="cbv2-nest-name">{clinic.name}</span>
                                {clinic.address && <span className="cbv2-nest-addr">{clinic.address}</span>}
                              </div>
                              {!hasSlots ? (
                                <span className="cbv2-next-chip">No availability on selected date</span>
                              ) : (
                                <>
                                  {pickedSlotLabel && <span className="cbv2-picked-badge">{pickedSlotLabel}</span>}
                                  <span className="cbv2-chevron" style={{ fontSize: 13, marginLeft: 8 }}>
                                    {isNestOpen ? '▲' : '▼'}
                                  </span>
                                </>
                              )}
                            </div>

                            {hasSlots && isNestOpen && (
                              <div className="cbv2-slots-area">
                                <div className="cbv2-filter-row">
                                  <span className="cbv2-filter-label">Time of day:</span>
                                  {[
                                    { val: 'all', label: 'All day', show: true },
                                    { val: 'am', label: 'AM', show: hasAM },
                                    { val: 'pm', label: 'PM', show: hasPM },
                                  ].filter(f => f.show).map(f => (
                                    <div
                                      key={f.val}
                                      className={`cbv2-fchip${filterVal === f.val ? ' on' : ''}`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        const nextVal = filterVal === f.val ? 'all' : f.val;
                                        logInteraction("am_pm_filter_applied", { filter: nextVal, date: day, clinic_id: cid });
                                        setClinicFilters(prev => ({ ...prev, [key]: nextVal }));
                                      }}
                                    >
                                      {f.label}
                                    </div>
                                  ))}
                                </div>
                                {filterVal ? (
                                  filtered.length === 0 ? (
                                    <div style={{ fontSize: 12, color: '#999', padding: '8px 0' }}>No slots available</div>
                                  ) : filterVal === 'all' ? (
                                    [
                                      { label: 'AM', slots: filtered.filter(s => s.start_time < '12:00') },
                                      { label: 'PM', slots: filtered.filter(s => s.start_time >= '12:00') },
                                    ].filter(g => g.slots.length > 0).map(g => (
                                      <React.Fragment key={g.label}>
                                        <div className="cbv2-slot-group-label">{g.label}</div>
                                        <div className="cbv2-slots-grid">
                                          {g.slots.map(slot => {
                                            const slotKey = `${day}_${cid}_${slot.start_time}-${slot.end_time}`;
                                            const isSelected = selectedSlots.includes(slotKey);
                                            const isUnavailable = slot.availablity_status == 0;
                                            return (
                                              <div
                                                key={slotKey}
                                                className={`cbv2-slot${isSelected ? ' picked' : ''}`}
                                                style={{ opacity: isUnavailable ? 0.5 : 1, cursor: isUnavailable ? 'not-allowed' : 'pointer' }}
                                                onClick={() => !isUnavailable && toggleSlot(slotKey, slot, day, cid)}
                                              >
                                                {slot.start_time}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </React.Fragment>
                                    ))
                                  ) : (
                                    <div className="cbv2-slots-grid">
                                      {filtered.map(slot => {
                                        const slotKey = `${day}_${cid}_${slot.start_time}-${slot.end_time}`;
                                        const isSelected = selectedSlots.includes(slotKey);
                                        const isUnavailable = slot.availablity_status == 0;
                                        return (
                                          <div
                                            key={slotKey}
                                            className={`cbv2-slot${isSelected ? ' picked' : ''}`}
                                            style={{ opacity: isUnavailable ? 0.5 : 1, cursor: isUnavailable ? 'not-allowed' : 'pointer' }}
                                            onClick={() => !isUnavailable && toggleSlot(slotKey, slot, day, cid)}
                                          >
                                            {slot.start_time}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )
                                ) : (
                                  <div className="cbv2-slot-placeholder">Select a time of day to see available slots.</div>
                                )}
                              </div>
                            )}
                          </div>
                        );
                      });
                    })()}
                  </div>
                )}
              </div>
            );
          })
        )}

        {/* Load More */}
        {allDayKeys.length > 0 && metaData?.current_page < metaData?.last_page && (
          <div className="cbv2-load-more-wrap">
            {loadingMoreDates ? (
              <Spin size="small" className="custom-spinner" />
            ) : (
              <button className="cbv2-load-more-btn" onClick={getLoadMoreData}>
                Load More <span>∨</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
    );
  };

  // ── Continue: block the picked slot then advance to patient details ───────
  // NOTE: the "cbv2" redesign lets the admin pick clinic+slot in one screen, so
  // Continue passes type="AppointmentSelection" straight to callbackClinicBooking
  // to skip the old AppointmentSelection.js grid-picker screen (ClinicCalendarPage.js
  // renders BookingDetailsNext when showAppoinmentDataDisplay=="AppointmentSelection",
  // not the AppointmentSelection component). That skip previously also skipped the
  // block-slot call that used to live inside that screen's own Continue handler —
  // meaning the slot was never actually held server-side. Fixed by calling it here.
  const handleContinueButton = async () => {
    if (!selectedClinicsStartAndEndTime || selectedClinicsStartAndEndTime.length === 0) return;
    const slotEntry = selectedClinicsStartAndEndTime[0];
    const clinicId = slotEntry.clinic_id?.length > 0 ? slotEntry.clinic_id[0] : selectedClinics[0];
    const clinicData = selectedClinicsNew?.find(c => (c.id || c.clinic_id) == clinicId) || { id: clinicId, name: 'Selected Clinic' };
    const productCategory = props.showAppoinmentData?.clinic?.productCategory;
    const isHS = productCategory?.type === 'd2c' || productCategory?.type === 'corporate';
    const payload = {
      clinic_id: clinicData.id,
      start_time: moment(`${slotEntry.date} ${slotEntry.start_time}`).format("YYYY-MM-DD HH:mm"),
      end_time: moment(`${slotEntry.date} ${slotEntry.end_time}`).format("YYYY-MM-DD HH:mm"),
      product_category_id: productCategory?.product_category_id,
      ...(isHS && { product_id: Number(props.showAppoinmentData?.clinic?.non_gp_product_id) }),
    };

    logInteraction("clinic_booking_continue_clicked", {
      selected_clinics: selectedClinics,
      selected_slot: slotEntry.date + slotEntry.start_time,
    });

    setBlockingSlot(true);
    try {
      // Mirror AppointmentSelection.js pattern: attach existing session_id, then
      // clear stale keys before the call so a fresh session is stored after.
      const existingSession = localStorage.getItem("bookingSessionId");
      if (existingSession) payload.session_id = existingSession;
      localStorage.removeItem("bookingSessionId");
      localStorage.removeItem("bookingExpiresAt");

      const res = await genericApiCall("block-slot", payload);

      if (Array.isArray(res) && !res.length) {
        pushTraceLogEvent({
          event: "block_slot_failed",
          payload: { clinic_id: clinicData.id, start_time: payload.start_time, end_time: payload.end_time, reason: "empty_response" },
          step_status: "failed",
        });
        throw new Error(res.data?.message || "This slot is already selected by another user. Please choose another slot.");
      }

      const session_id = res.data?.data?.session_id ?? res.data?.session_id;
      const expires_at = res.data?.data?.expires_at ?? res.data?.expires_at;
      if (session_id) {
        localStorage.setItem("bookingSessionId", session_id);
        if (expires_at) localStorage.setItem("bookingExpiresAt", expires_at);
      } else {
        console.warn("[ClinicBooking] block-slot response missing session_id — slot_session_id will not be available downstream.", res.data);
      }
      pushTraceLogEvent({
        event: "slot_blocked",
        payload: {
          clinic_id: clinicData.id,
          clinic_name: clinicData.name,
          start_time: payload.start_time,
          end_time: payload.end_time,
          product_category_id: payload.product_category_id,
          date: new Date().toISOString().split("T")[0],
          slot_session_id: session_id,
        },
        step_status: "success",
      });

      const payloadPassNew = {
        selectedClinics,
        slot: { date: slotEntry.date, info: slotEntry.info, clinicData },
        type: "PreferredTimeclinic",
      };
      props.callback(payloadPassNew, "AppointmentSelection");
    } catch (err) {
      messageApi.error({ content: err.message || "Unable to block the slot." });
    } finally {
      setBlockingSlot(false);
    }
  };

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      {contextHolder}

      {/* Booking summary header */}
      <div style={{ display: "grid", justifyContent: "center" }}>
        <div style={{ width: "605px", background: "#00838540", padding: 10, marginTop: 40 }}>
          <Title style={{ margin: 0, fontSize: 20, color: "#008385", fontWeight: "400" }}>My booking:</Title>
        </div>
      </div>
      <div className="summuryCard" style={{ width: 394, marginTop: 20, flexDirection: "column", alignItems: "center", gap: 0 }}>
        <span style={{ whiteSpace: "pre-line", textAlign: "center" }}>
          {props?.showAppoinmentData.clinic?.productCategory?.name
            ? props?.showAppoinmentData.clinic?.productCategory?.name
            : props?.showAppoinmentData.clinic?.clinic?.productCategory?.name || ""}
          {(() => {
            const _cbCatType = props?.showAppoinmentData.clinic?.productCategory?.type || (props?.showAppoinmentData.clinic?.productCategory?.product_category_id == 1 ? 'gp' : props?.showAppoinmentData.clinic?.productCategory?.product_category_id == 3 ? 'corporate' : 'd2c');
            return (
              <>
                {_cbCatType === 'gp' ? "\n" : ""}{" "}
                {_cbCatType !== 'gp' ? <br /> : ""}
                {_cbCatType !== 'gp' && _cbCatType !== 'corporate' && props?.showAppoinmentData.clinic.non_gp_product_id && props.getAllHealthScreenData?.getAllHealthScreenData?.data
                  ? filterByNonGpProductId(props.getAllHealthScreenData.getAllHealthScreenData.data, props?.showAppoinmentData.clinic.non_gp_product_id)?.[0]?.name || ""
                  : ""}
                {_cbCatType === 'corporate'
                  ? filterByNonGpProductId(props?.showAppoinmentData.clinic?.selectedCorporate?.corporate_products, props?.showAppoinmentData.clinic.non_gp_product_id)?.[0]?.name || ""
                  : ""}
              </>
            );
          })()}
        </span>
        {(() => {
          const visibleChips = tempDataForDuration.filter(rs => {
            if (rs.key === "Gender" && rs.data.toLowerCase() === "no preference") return false;
            return true;
          });
          if (!visibleChips.length) return null;
          return (
            <div style={{ fontSize: 13, display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '0 4px' }}>
              {visibleChips.map((rs, i) => (
                <React.Fragment key={rs.key ?? i}>
                  <span style={{ color: '#000' }}>{rs.key}:&nbsp;<span style={{ color: '#008385', fontWeight: 500 }}>{rs.data}</span></span>
                  {i !== visibleChips.length - 1 && <span style={{ color: '#000', margin: '0 6px' }}>|</span>}
                </React.Fragment>
              ))}
            </div>
          );
        })()}
      </div>

      {/* Two-Column Grid */}
      <div className="cbv2-columns" style={{ marginTop: '1rem' }}>

        {/* LEFT PANEL: Clinic list */}
        <div className="cbv2-panel" ref={leftPanelRef}>
          <div className="cbv2-ph">
            <span className="cbv2-ptitle">Preferred clinic</span>
          </div>

          <div className="cbv2-loc-actions">
            <div style={{ width: '100%' }}>
              {searchBylocationOption && (
                <LocationSearchSelect
                  options={searchBylocationOption}
                  loading={loadingLocation}
                  searchValue={searchBylocationName}
                  onSelect={onSelectLocation}
                  onSearch={(value) => {
                    setsearchBylocationName(value);
                    // Show the loader from the moment a real search kicks in (not
                    // just during the network call) — the actual fetch only starts
                    // after an 800ms debounce, so waiting for getAllSearchData's own
                    // setloadingLocation(true) left the spinner's visible window too
                    // short to notice.
                    setloadingLocation(!!(value && value.split(' ').join('').length >= 3));
                  }}
                />
              )}
            </div>
          </div>

          <div className="cbv2-clinic-hint">You can select up to 3 clinics</div>

          <div className="cbv2-clinic-list">
            {selectedClinicsNew && selectedClinicsNew.length ? (
              [...selectedClinicsNew]
                .sort((a, b) => {
                  const aU = a.clinic_availability_status === false;
                  const bU = b.clinic_availability_status === false;
                  return aU === bU ? 0 : aU ? 1 : -1;
                })
                .map(a => {
                  if (a.status == "0") return null;
                  if (a.clinic_id) a.id = a.clinic_id;
                  const isUnavailable = a.clinic_availability_status === false;
                  const isSel = selectedClinics.includes(a.id.toString());
                  // When specific dates are chosen, next_available_slot isn't
                  // reliable per clinic (the API appears to echo back the queried
                  // date rather than that clinic's real availability) — use the
                  // clinic's own available_dates for those exact dates instead,
                  // matching what the right panel actually shows when expanded.
                  const hasSlotOnChosenDates = chosenDates.size > 0 &&
                    Array.from(chosenDates).some(d => (a.available_dates?.[d] || []).length > 0);
                  return (
                    <div
                      key={a.id}
                      className={`cbv2-clinic-row${isSel ? ' active' : ''}${isUnavailable ? ' unavail' : ''}`}
                      onClick={() => !isUnavailable && toggleClinic(a)}
                      onMouseEnter={() => !isUnavailable && setHoveredClinic(a)}
                      onMouseLeave={() => setHoveredClinic(null)}
                    >
                      <div className="cbv2-clinic-main" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div className="cbv2-clinic-name">{a.name}</div>
                      </div>
                      {a.distance != null && (
                        <span className="cbv2-distance-chip">{a.distance}</span>
                      )}
                      {isUnavailable ? (
                        <span className="cbv2-unavail-tag">Unavailable</span>
                      ) : chosenDates.size > 0 ? (
                        <span className="cbv2-next-chip">
                          {hasSlotOnChosenDates ? 'Available on selected date' : 'No availability on selected date'}{chosenDates.size > 1 ? 's' : ''}
                        </span>
                      ) : a.next_available_slot ? (
                        <span className="cbv2-next-chip">
                          <ClockIcon /> Next available: {moment(a.next_available_slot.date).format("ddd, DD MMM")} {a.next_available_slot.start_time}
                        </span>
                      ) : (
                        <span className="cbv2-next-chip">No upcoming availability</span>
                      )}
                      {!isUnavailable && (
                        <div className={`cbv2-chk${isSel ? ' on' : ''}`}>{isSel && '✓'}</div>
                      )}
                    </div>
                  );
                })
            ) : loading ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}><Spin className="custom-spinner" /></div>
            ) : (
              <div className="cbv2-empty-state">No clinics found</div>
            )}
          </div>
        </div>

        {/* RIGHT PANEL: Location map (no clinic selected) OR Preferred time slots (clinic selected) */}
        {/* Called as plain functions, not rendered as <Component/> — these are
            redefined on every ClinicBooking render (they close over local state),
            so using them as JSX elements makes React treat them as a "new"
            component type each time, forcing a full unmount/remount of the whole
            panel (and resetting its scroll position) on every click. Calling them
            directly keeps their output as part of this same render tree instead. */}
        {selectedClinics.length === 0 ? LocationDetailsPanel() : PreferredTimePanel()}
      </div>

      {/* Bottom Action Bar */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 16, marginTop: 40, paddingBottom: 40 }}>
        <Button
          style={{ borderRadius: '999px', height: 40, padding: '0 24px', borderColor: '#d9d9d9', color: '#333', fontSize: 14, fontWeight: 500, background: '#fff' }}
          onClick={() => {
            props.callBackForbackpage && props.callBackForbackpage('BookingForm');
            pushTraceLogEvent({ event: "navigate_to_appointment_duration_selection", payload: { action: "navigate to appointment duration selection" }, step_status: "success" });
          }}
        >
          ← Back
        </Button>
        <Button
          type="primary"
          disabled={!selectedClinicsStartAndEndTime || selectedClinicsStartAndEndTime.length === 0 || blockingSlot}
          loading={blockingSlot}
          style={{
            background: selectedClinicsStartAndEndTime?.length > 0 ? '#008385' : '#ccc',
            borderColor: selectedClinicsStartAndEndTime?.length > 0 ? '#008385' : '#ccc',
            borderRadius: '999px',
            height: 40,
            padding: '0 32px',
            fontSize: 14,
            fontWeight: 600,
          }}
          onClick={handleContinueButton}
        >
          {blockingSlot ? "Booking..." : "Continue"}
        </Button>
      </div>
    </>
  );
};

export default ClinicBooking;
